(function (app) {
    "use strict";

    const AssignEmployeesSelect = function ($scope, deviceChecker, TSUsersService, ScheduleDataServiceV2, hEvent) {

        var self = this;
        var _emitter = JarEventEmitter.call(self);
        var eventData;

        var CONSTANTS = {
            OVERLAY_CLASS: 'assignee-overlay',
            OVERLAY_SELECTOR: '.assignee-overlay',
            MENU_SELECTOR: '.assign-employees-select',
            SHOWN_CLASS: 'shown',
            BODY_CLASS: 'overflow-hidden'
        };

        var EVENTS = {
            EMPLOYEE_UNASSIGNED: "unAssignEmployee",
            EMPLOYEES_UPDATED: "assigneesUpdated"
        };

        var overlayElm;

        self.searchPhrase = '';

        self.setScheduleId = function (scheduleId) {
            self.schedule_id = scheduleId;
        };

        self.onAssigneesUpdated = function (handler) {
            return self.on(EVENTS.EMPLOYEES_UPDATED, handler);
        };

        self.onUnAssignEmployee = function (handler) {
            return self.on(EVENTS.EMPLOYEE_UNASSIGNED, handler);
        };

        //Load slot resources
        var loadSlotResources = function (role, day, brand) {
            var defer = $q.defer();
            var brandId = brand.id;
            var nowInBrandTimezone = moment(Utils.getNowInBrandTimezoneByTimeZoneName(brand.timezoneName).format("YYYY-MM-DDTHH:mm:ss.SSS"));

            self.loadingResources = true;
            syncScope();
            self.resources = [];
            var formattedDate = day? day.format("MMM DD, YYYY"): null;

            TSUsersService.getBrandTeamUsers(brandId, true, TSUsersService.EMPLOYEE_VIEW_STATUS.ACTIVE, TSUsersService.SCHEDULABLE.REGULAR)
                .then(function(users) {

                    //Load the resources
                    for (var i in users) {
                        var user = angular.copy(users[i]);
                        var userActivePaytype = TSUsersService.getUserActivePayType(user.id, day, self.viewType);
                        var userHasSelectedPosition = _.find(user.positions, function (userPosition) {
                            return userPosition.code === role.position.code;
                        });

                        var selectedRoleDay;
                        var userAssignedToSelectedDay;
                        if (self.viewType === 'DAILY') {
                            selectedRoleDay = formattedDate && role.role_days.find(function (roleDay) {
                                return roleDay.date === formattedDate;
                            });

                            userAssignedToSelectedDay = selectedRoleDay && selectedRoleDay.assignees.find(function (assignee) {
                                return assignee.user_id === user.id;
                            });
                        } else {
                            userAssignedToSelectedDay = role.user_ids.indexOf(user.id) > -1;
                        }

                        if (user.schedulable === 'REGULAR' && userHasSelectedPosition && formattedDate &&
                            user.isDateWithinActiveOrScheduledLocationPeriod(formattedDate, nowInBrandTimezone, self.viewType) && !userAssignedToSelectedDay) {
                            user.assigned = false;
                            user.userWithEffectivePayType = !!userActivePaytype;
                            self.resources.push(user);
                        }
                    }

                    self.loadingResources = false;
                    defer.resolve(self.resources);
                    syncScope();
                });

            return defer.promise;
        };

        //Load slot resources
        var loadEmployeeSlotResources = function (scheduleId, day, brand) {
            var defer = $q.defer();

            self.loadingResources = true;
            syncScope();
            self.resources = [];
            var brandId = brand.id;
            var nowInBrandTimezone = moment(Utils.getNowInBrandTimezoneByTimeZoneName(brand.timezoneName).format("YYYY-MM-DDTHH:mm:ss.SSS"));

            //Load the resources
            TSUsersService.getBrandTeamUsers(brandId, true, TSUsersService.EMPLOYEE_VIEW_STATUS.ACTIVE, TSUsersService.SCHEDULABLE.REGULAR)
                .then(function (users) {
                    var formattedDate = day ? day.format("MMM DD, YYYY"): null;

                    for (var i in users) {
                        var user = angular.copy(users[i]);
                        var userActivePaytype = TSUsersService.getUserActivePayType(user.id, day, self.viewType);
                        var userAssignedToSelectedDay = false;

                        if (self.category) {
                            var userAssignedToSelectedCategory = false;
                            var userRoleIds = ScheduleDataServiceV2.flatData['users'] && ScheduleDataServiceV2.flatData['users'][user.id] && ScheduleDataServiceV2.flatData['users'][user.id].role_ids || [];

                            var userHasMatchingCategory = _.find(user.positions, function (position) {
                                return position.category.code.toLowerCase() === self.category.toLowerCase();
                            });

                            if (userHasMatchingCategory && userRoleIds.length) {
                                for (var i in userRoleIds) {
                                    var roleInfo = ScheduleDataServiceV2.flatData['roles'][userRoleIds[i]];
                                    var userMatchingCategory = roleInfo.position.category.code.toLowerCase() === self.category.toLowerCase();

                                    if (userMatchingCategory) {
                                        if (self.viewType === 'DAILY') {
                                            var selectedRoleDay = formattedDate && roleInfo.role_days.find(function (roleDay) {
                                                return roleDay.date === formattedDate;
                                            });

                                            userAssignedToSelectedDay = selectedRoleDay && selectedRoleDay.assignees.find(function (assignee) {
                                                return assignee.user_id === user.id;
                                            });
                                        } else {
                                            userAssignedToSelectedDay = roleInfo.user_ids.indexOf(user.id) > -1;
                                        }

                                        userAssignedToSelectedCategory = userAssignedToSelectedCategory || userAssignedToSelectedDay;
                                    }
                                }
                            }

                            if (userHasMatchingCategory && user.isDateWithinActiveOrScheduledLocationPeriod(formattedDate, nowInBrandTimezone, self.viewType) && !userAssignedToSelectedCategory) {
                                user.userWithEffectivePayType = !!userActivePaytype;
                                self.resources.push(user);
                            }
                        } else {
                            var arrayOfUsersOnSchedule = (ScheduleDataServiceV2.flatData['users'] && Object.keys(ScheduleDataServiceV2.flatData['users'])) || [];

                            if (self.viewType === 'DAILY') {
                                arrayOfUsersOnSchedule = ScheduleDataServiceV2.flatData['days'][formattedDate] && ScheduleDataServiceV2.flatData['days'][formattedDate]['user_ids'] || []
                            }

                            arrayOfUsersOnSchedule = arrayOfUsersOnSchedule.map(function (userId) {
                                return parseInt(userId);
                            });

                            userAssignedToSelectedDay = arrayOfUsersOnSchedule.indexOf(user.id) > -1;

                            if (user.isDateWithinActiveOrScheduledLocationPeriod(formattedDate, nowInBrandTimezone, self.viewType) && !userAssignedToSelectedDay) {
                                user.userWithEffectivePayType = !!userActivePaytype;
                                self.resources.push(user);
                            }
                        }
                    }

                    self.loadingResources = false;
                    defer.resolve(self.resources);

                    syncScope();
                });

            return defer.promise;
        };

        //Toggle the slot dropdown menu
        self.toggleSlotDropdown = function () {
            self.slotDropdownToggled = !self.slotDropdownToggled;
        };

        //show it
        self.show = function (scheduleElm, roles, category, day, viewType, brand, canPublish, scheduleStatus) {

            //reset the search phrase
            self.searchPhrase = '';
            self.roles = roles || [];
            self.day = day;
            self.category = category;
            self.viewType = viewType;
            eventData = {
                'brand_id': brand.id,
                'schedule_id': self.schedule_id,
                'schedule_status': scheduleStatus,
                'user_with_approval': canPublish,
                'tag': 'schedule_creation'
            };

            //find the slot element
            var slotEl = scheduleElm.find('.assign-emp-actions');
            var menuElm = $(CONSTANTS.MENU_SELECTOR);

            //add overlay if not already shown
            if (!$(CONSTANTS.OVERLAY_SELECTOR).length && !deviceChecker.isMobile()) {
                overlayElm = $("<div></div>");

                overlayElm
                    .addClass(CONSTANTS.OVERLAY_CLASS)
                    .appendTo('body').fadeIn();

                overlayElm.click(function () {
                    self.hide();
                });
            }

            //calculate for top & left in case of desktop
            if (!deviceChecker.isMobile()) {
                var activeShiftEl = slotEl;
                var activeShiftWidth = activeShiftEl.outerWidth();

                var leftOffset = activeShiftEl.offset().left + activeShiftWidth - scheduleElm.offset().left + 10;

                if (($(window).width() - leftOffset) < menuElm.outerWidth()) {
                    leftOffset -= (activeShiftWidth + menuElm.outerWidth());
                }

                const topOffset = slotEl.offset().top - $(`.scheduling-page`).offset().top - 35;
                leftOffset += 10;
                menuElm.css({"top": topOffset + "px", "left": leftOffset + "px"});
            }

            $('body').addClass(CONSTANTS.BODY_CLASS);

            menuElm.addClass(CONSTANTS.SHOWN_CLASS);

            var promise;

            // Load the resources
            if (self.roles.length === 1 && !self.category) {
                promise = loadSlotResources(self.roles[0], self.day, brand);
            } else {
                promise = loadEmployeeSlotResources(self.schedule_id, self.day, brand);
            }

            promise.then(function (res) {
                setTimeout(function () {
                    $("#select-search-input").focus();
                }, 1);
            });
        };

        self.hide = function () {
            overlayElm && overlayElm.remove();

            $(CONSTANTS.MENU_SELECTOR).removeClass(CONSTANTS.SHOWN_CLASS);
            $('body').removeClass(CONSTANTS.BODY_CLASS);
        };

        self.unAssignEmployee = function (employee) {
            // delete after exact adding so no shifts added

            if (employee.processing || employee.disabled) {
                return;
            }

            employee.processing = true;
            var formattedDay = (self.day && self.viewType === 'DAILY')? self.day.format("MMM DD, YYYY"): null;

            var deletePromises = [];

            if (self.roles.length > 0) {
                for (var i in self.roles) {
                    var role = self.roles[i];

                    if (role.user_ids.indexOf(employee.id) > -1) {
                        deletePromises.push(TeamScheduleAPI.deleteRoleAssignees(self.schedule_id, role.id, employee.id, formattedDay, false));
                    }
                }
            } else {
                deletePromises.push(TeamScheduleAPI.deletePersonFromSchedule(self.schedule_id, employee.id, formattedDay, false));
            }

            $q.all(deletePromises)
                .then(function () {
                    employee.assigned = false;
                    _emitter.trigger(EVENTS.EMPLOYEE_UNASSIGNED, self.roles, employee, formattedDay);
                })
                .catch(function (err) {
                    console.error(err);
                })
                .finally(function () {
                    employee.processing = false;
                    $scope.$digest();
                });
        };

        self.selectEmployee = function (employee) {
            if (employee.assigned || employee.processing || employee.disabled || !employee.userWithEffectivePayType || employee.isAllPeriodLoa(self.day, self.viewType)) {
                return;
            }

            employee.processing = true;
            var formattedDay = (self.day && self.viewType === 'DAILY')? self.day.format("MMM D, YYYY"): null;

            var addPromise;

            if (self.roles.length && !self.category) {
                addPromise = TeamScheduleAPI.addRoleAssignees(ScheduleDataServiceV2.brandId, self.schedule_id, self.roles[0].id, [employee.id], formattedDay);
            } else {
                var position_code;
                var emp = _.findWhere(self.resources, {id: employee.id});

                if (emp && !emp.disabled && emp['positions'].length) {
                    for (var i in emp['positions']) {
                        var employeePosition = emp['positions'][i];

                        if (self.category) {
                            if (self.category.toLowerCase() === employeePosition.category.code.toLowerCase()) {
                                position_code = employeePosition.code;
                                break;
                            }
                        }
                        else {
                            position_code = employeePosition.code;
                            break;
                        }
                    }

                }

                if (position_code) {
                    // assign him to position_code (role will be generated on the server)
                    addPromise = TeamScheduleV2API.addAvailableEmployee(self.schedule_id, [employee.id], formattedDay, position_code);
                } else {
                    hAlert($filter("translate")("Error"), $filter("translate")("Employee has no positions assigned to them."));
                    employee.processing = false;
                }
            }

            if (addPromise) {
                addPromise
                    .then(function (data) {
                        employee.processing = false;
                        employee.assigned = true;
                        // employee.assigneeId = data.assignee.id;
                        _emitter.trigger(EVENTS.EMPLOYEES_UPDATED, data['role']);
                        eventData.event_status = 'SUCCESS';
                        hEvent.dwhTrack('schedule_add_employees_select_add_employees', eventData);
                        $scope.$digest();
                    }, function (err) {
                        console.error(err);
                        employee.processing = false;
                        eventData.event_status = 'FAIL';
                        hEvent.dwhTrack('schedule_add_employees_select_add_employees', eventData);
                    });
            }

        };


        var syncScope = function () {
            setTimeout(function () {
                $scope.$digest();
            }, 1);
        }

    };

    app.service('AssignEmployeesSelect', ["deviceChecker","TSUsersService", 'ScheduleDataServiceV2', 'hEvent', function (deviceChecker, TSUsersService, ScheduleDataServiceV2, hEvent) {
        return function (scope) {
            return new AssignEmployeesSelect(scope, deviceChecker, TSUsersService, ScheduleDataServiceV2, hEvent);
        }
    }]);

})(angular.module('harriApp'));

